import type { NotifierPort } from "./ports";

/**
 * Notificador global configurable (implementación del NotifierPort).
 *
 * La lógica de negocio portable (hooks compartidos web/móvil) no puede importar
 * `sonner` ni ningún toast de plataforma. En su lugar usan este `notify`, y cada
 * plataforma registra su implementación una vez al arrancar con
 * `configureNotifier` (web = sonner, móvil = nuestro toast). Por defecto cae a
 * consola, así nunca rompe si aún no se configuró.
 */
const consoleNotifier: NotifierPort = {
  success: (m) => console.log("[notify]", m),
  error: (m) => console.error("[notify]", m),
  info: (m) => console.log("[notify]", m),
};

let current: NotifierPort = consoleNotifier;

/** Registra el notificador de la plataforma. Llamar una vez al inicio. */
export function configureNotifier(n: NotifierPort): void {
  current = n;
}

/**
 * Notificador activo. Objeto estable cuyos métodos delegan en el notificador
 * configurado, para que los hooks lo capturen una vez sin quedar obsoletos.
 */
export const notify: NotifierPort = {
  success: (m) => current.success(m),
  error: (m) => current.error(m),
  info: (m) => current.info(m),
};
